var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"containerApp"},[_c('Header'),_c('Atenciones',{staticClass:"bodyApp"}),_c('drawer',{attrs:{"hide":true}}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }